export default "__VITE_ASSET__215695df__"